<p>
  Estás en:
  <ng-container *ngFor="let breadcrumb of breadcrumbs; let last = last">
    <a href="" class="breadcrumb-item breadLink" [ngClass]="{ active: last }"
      >{{ breadcrumb.label }}
    </a>
    <span *ngIf="!last" class="material-symbols-outlined chevron_right">
      chevron_right
    </span>
  </ng-container>
</p>
